import { useIntl } from 'react-intl';
import { IconFileDescription } from '@rossum/ui/icons/tabler';
import { Chip, Stack, SvgIcon, Typography } from '@rossum/ui/material';

type CollapsibleListHeaderProps = {
  count: number | undefined;
};

export const CollapsibleListHeader = ({
  count,
}: CollapsibleListHeaderProps) => {
  const intl = useIntl();
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography
        variant="subtitle2"
        color="text.secondary"
        data-cy="attachements-list-title"
      >
        <Stack direction="row" component="span" spacing={2}>
          <SvgIcon fontSize="medium" color="inherit">
            <IconFileDescription />
          </SvgIcon>
          <span>
            {intl.formatMessage({
              id: 'components.emailDocumentsPreview.title',
            })}
          </span>
        </Stack>
      </Typography>
      {count && <Chip label={count} />}
    </Stack>
  );
};
